import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Wraps routes that require a session, and optionally a specific permission.
 *
 *   <ProtectedRoute><Dashboard /></ProtectedRoute>
 *   <ProtectedRoute permission="admins.view"><AdminsPage /></ProtectedRoute>
 *   <ProtectedRoute anyPermission={['a.view', 'b.view']}>…</ProtectedRoute>  (any one is enough)
 */
export default function ProtectedRoute({ permission, anyPermission, children }) {
  const { isAuthenticated, loading, can } = useAuth();
  const location = useLocation();

  if (loading) return <div className="spinner">Loading…</div>;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const denied = permission ? !can(permission) : anyPermission ? !anyPermission.some(can) : false;
  if (denied) {
    return (
      <div className="content">
        <div className="notice notice-error">
          You don't have permission to view this page.
        </div>
      </div>
    );
  }

  return children;
}
